<div [appCustomTooltip]=tooltip placement="top" style="height: 100%">
  @if (efficiency === null) {
    <div [style.backgroundColor]="'--divider' | themeColor | async" [style.border]="'1px solid ' + ('--secondary'| themeColor | async)" [style.height.%]="100"></div>
  }
  @if (efficiency !== null) {
    @if (efficiency !== null) {
      <div [style.backgroundColor]="'--red'| themeColor | async" [style.height.%]="100 - efficiency"></div>
    }
    @if (efficiency !== null) {
      <div [style.backgroundColor]="'--primary-background'| themeColor | async" [style.height.%]="efficiency"></div>
    }
  }
</div>

<ng-template #tooltip>
  @if (efficiency !== null) {
    <span class="text-primary">{{ efficiency | number:'1.0-0' | customNumberFormat }}%</span>
  }
  @if (efficiency === null) {
    <span class="text-primary">0%</span>
  }
</ng-template>
